module.exports = __webpack_public_path__ + "static/media/cloudy-night-2.ef1c6aa1.svg";